import { render, staticRenderFns } from "./GenericForm.vue?vue&type=template&id=be0ac494&lang=html&"
import script from "./GenericForm.vue?vue&type=script&lang=js&"
export * from "./GenericForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports